import React from 'react';
import { ScrollReveal } from './ScrollReveal';
export function ProblemSection() {
  return <section className="py-28 px-6 bg-cream-light relative" data-id="element-104">
      <div className="max-w-6xl mx-auto" data-id="element-105">
        <ScrollReveal width="100%" className="mb-16 text-center md:text-left" data-id="element-106">
          <span className="text-xs font-sans font-medium tracking-editorial text-slate uppercase border-b border-slate/20 pb-2" data-id="element-107">
            The Core Problem
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-ink mt-8 leading-tight" data-id="element-108">
            The Real Reason Your Success Feels Heavy
          </h2>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-24 items-start" data-id="element-109">
          <div data-id="element-110">
            <ScrollReveal delay={0.2} data-id="element-111">
              <p className="font-sans text-base md:text-lg leading-relaxed text-slate-dark font-light" data-id="element-112">
                <span className="float-left text-7xl font-serif leading-[0.8] pr-4 pt-2 text-ink" data-id="element-113">
                  Y
                </span>
                ou built something that works. Revenue is flowing. Clients are
                coming in. But somewhere along the way, the business that was
                supposed to create freedom started feeling like a cage.
              </p>
              <p className="font-sans text-base md:text-lg leading-relaxed text-slate-dark mt-6 font-light" data-id="element-114">
                Here's what most people won't tell you: the problem isn't your
                strategy. It's not your funnel. It's not even your team. The
                real issue is that you've evolved as a leader, but your business
                is still running on an outdated version of you.
              </p>
            </ScrollReveal>
          </div>

          <div className="flex flex-col justify-between h-full" data-id="element-115">
            <ScrollReveal delay={0.4} data-id="element-116">
              <p className="font-sans text-base md:text-lg leading-relaxed text-slate-dark mb-12 font-light" data-id="element-117">
                This creates a hidden friction that shows up as inconsistent
                revenue, reactive decision-making, and that constant feeling of
                being stretched too thin. You've been trying to solve an
                internal misalignment problem with external tactics. And that's
                why nothing has worked.
              </p>
            </ScrollReveal>

            <ScrollReveal delay={0.6} className="mt-auto" data-id="element-118">
              <blockquote className="font-serif italic text-3xl md:text-4xl text-ink leading-tight border-l-2 border-slate/30 pl-6 py-2" data-id="element-119">
                "It's not your fault that the scaling strategies felt hollow.
                Those solutions were built for a different problem entirely."
              </blockquote>
            </ScrollReveal>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full h-px bg-ink/10" data-id="element-120" />
    </section>;
}